import { Heading, Text } from '@checkatrade/web-ui';

const Title = ({
  title,
  description,
  className,
}: {
  title: string;
  description?: string;
  className?: string;
}) => {
  return (
    <div className={className}>
      <Heading
        as="h3"
        weight="semibold"
        variant="titleSM"
        className="mb-1  text-default-700"
      >
        {title}
      </Heading>
      {description && (
        <Text className="text-sm text-neutral-800">{description}</Text>
      )}
    </div>
  );
};

export default Title;
